const BlockStatementDefault = {
    object_id : null,
    name : 'Prompt',
    x : 0,
    y : 0,
    width : 5,
    height : 3,
    type : { name : 'propos'},
    data : {
        messages : [
            {type: "text", content: "Lorem ipsum dolor sit amet"},
        ],
        responses : [
            {type: "custom", content: "Custom Response"}
        ],
        has_background_text: false,
        background_content: "",
        retries: 1,
        hangup_no_response: true,
        listening_during_prompt_delay: 0,
    },
    children : [
        {text: "", index : null, object_id : null, parent_block_id : null},
        {text: "Custom Response", index : null, object_id : null, parent_block_id : null}
    ]
}

const BlockStatementServerDefault = {
    type : 'propos',
    messages : [
        {type: "text", content: "Lorem ipsum dolor sit amet"},
    ],
    responses : [
        {type: "custom", content: "Custom Response"}
    ],
}

export {BlockStatementDefault, BlockStatementServerDefault} 